const RankManagementReducer = (state = {}, action) => {
    switch (action.type) {
      case "getSearchRankSuccess": {
        return Object.assign({}, state, {
          RankList: action.data,
        });
        break;
      }
      case "RankDetail": {
        return Object.assign({}, state, {
          RankDetail: action.data,
        });
        break;
      }
      case "getSearchAllRankSuccess": {
        return Object.assign({}, state, {
          AllRank: action.data,
        });
        break;
      }
      default: {
        return state;
      }
    }
  };
  export default RankManagementReducer;
  